import axios from '../request/http';

const supplyChain = {
    // 易企顺商品列表
    yiQishunList(params) {
        return axios.get("/admin/yqs/goods/list", {params});
    },
    // 更新易企顺商品状态
    yiQishunUpdate(params) {
        return axios.get("/admin/yqs/goods/status/update", {params});
    },
    // 易企顺商品库全量同步
    yiQishunGoodsUpdate(params) {
        return axios.get("/admin/yqs/goods/update", {params});
    },
    // 易企顺商品订单同步
    yiQishunGoodsOrderUpdate(params) {
        return axios.get("/admin/yqs/order/notify", {params});
    },
    //批量修改订单状态 
    yiQishunGoodsManyUpdate(params) {
        return axios.get("/admin/yqs/goods/statusUpdate", {params});
    },
    // 胜天半子分组列表
    shengTianGroup(params) {
        return axios.get("/admin/stbz/GoodsGroup/ApiLists", {params});
    },
    // 胜天半子商品列表
    shengTianGroupProduct(params) {
        return axios.get("/admin/stbz/GoodsGroup/ApiGoodsList", {params});
    },
    // 胜天半子商品详情
    shengTianDetail(params) {
        return axios.get("/admin/stbz/Goods/Detail", {params});
    },
    // 胜天半子商品加入酒水盲盒
    shengTianBlind(params) {
        return axios.get("/admin/stbz/goods/toBox", {params});
    },
    // 胜天半子供应链产品加入平台产品库
    shengTianBlindPlatform(params) {
        return axios.get("/admin/stbz/goods/toPlatform", {params});
    },

}

export default supplyChain;


// WEBPACK FOOTER //
// ./src/api/supplyChain.js